import { render } from "./userCompetition.vue?vue&type=template&id=d549d11a&scoped=true"
import script from "./userCompetition.vue?vue&type=script&lang=js"
export * from "./userCompetition.vue?vue&type=script&lang=js"

import "./userCompetition.vue?vue&type=style&index=0&id=d549d11a&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d549d11a"]])

export default __exports__